import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import {
  FaArrowRight,
  FaClipboard,
  FaCloudDownloadAlt,
  FaCopy,
  FaForward,
  FaSave,
  FaShare,
  FaTrash,
  FaWindowClose,
} from "react-icons/fa";
import ReactModal from "react-modal";
import {
  ActivityIndicator,
  Clipboard,
  FlatList,
  StyleSheet,
  Switch,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { isIOS } from "react-device-detect";
import screenfull from "screenfull";
import Logo from "../assets/Logo";
import RotateImg from "../assets/rotate.gif";
import PositionLayedMap from "../components/Football/PositionLayedMap";
import {
  AddToActionLog,
  ClearActionLog,
  ClearCurrentAction,
  ClearFullAnalyseString,
  FetchMatchStringFromServer,
  PushMatchStringToServer,
  SetCurrentAction,
  SetFullAnalyseString,
  SetVideoControl,
} from "../redux/actions/controlAction";
import { freeKickAnalyzer, passAnalyzer } from "../utils/validations";
import { SSENSE_URL } from "../config/stepoutAPI";
import { trackEvent, getLastEventString } from "../utils/mixpanel";

const classifyPassType = (start, end, isFromPSKey = false) => {
  const x1 = (start - 1) % 10;
  const y1 = Math.floor((start - 1) / 10);
  const x2 = (end - 1) % 10;
  const y2 = Math.floor((end - 1) / 10);
  const dx = Math.abs(x2 - x1);
  const dy = Math.abs(y2 - y1);

  const deepflankzone = [1, 2, 3, 11, 12, 13, 61, 62, 63, 71, 72, 73];
  const pboxzone = [21, 22, 31, 32, 41, 42, 51, 52];

  if (!isFromPSKey && deepflankzone.includes(start) && pboxzone.includes(end)) {
    return { type: "C", notation: "1" };
  }

  if ((dx <= 1 && dy <= 2) || (dx <= 2 && dy <= 1)) {
    return { type: "SP", notation: "1" };
  }
  return { type: "LP", notation: "1" };
};

const InputBoard = (props) => {
  const { matchId } = useParams();

  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [press, set] = useState([]);
  const [isLandscape, setIsLandscape] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [matchDetails, setMatchDetails] = useState(null);
  const [teamADetails, setTeamADetails] = useState(null);
  const [teamBDetails, setTeamBDetails] = useState(null);
  const [teamAPlayers, setTeamAPlayers] = useState(null);
  const [teamBPlayers, setTeamBPlayers] = useState(null);
  const [videoTimeFromServer, setVideoTimeFromServer] = useState(null);

  const [startPos, setStartPos] = useState("X");
  const [endPos, setEndPos] = useState("X");
  const [startCoordx1, setStartCoordx1] = useState("X");
  const [startCoordy1, setStartCoordy1] = useState("X");
  const [startCoordx2, setStartCoordx2] = useState("X");
  const [startCoordy2, setStartCoordy2] = useState("X");
  const [halfTag, setHalfTag] = useState("FHN");
  const [playerSelect, setPlayerSelect] = useState("X-X");
  const [actionAttrib, setActionAttrib] = useState("X");
  const [notate, setNotate] = useState("X");
  const [specialAction, setSpecialAction] = useState("X");
  const [actFoot, setActFoot] = useState("X");
  const [prevAction, setPrevAction] = useState("X-X-X-X-X-X-X-X-X-X-X-X-X-X");
  const [currAction, setCurrAction] = useState("X-X-X-X-X-X-X-X-X-X-X-X-X-X");
  const [secondAction, setSecondAction] = useState(
    "X-X-X-X-X-X-X-X-X-X-X-X-X-X",
  );
  const [secActFlag, setSecondActFlag] = useState(false);
  const [fullstringanalyse, setFullstringanalyse] = useState("");
  const [secondHalf, setSecondHalf] = useState(false);
  const [elapsedTime, setElapseTime] = useState(null);
  const [closeRequested, setCloseRequested] = useState(false);
  const [showDialog, setShowDialog] = useState(null);

  const [errorStrings, setErrorStrings] = useState(null);
  const [originalForFormating, setOriginalForFormating] = useState(null);
  const [stringLastTime, setStringLastTime] = useState("");
  const [stringStartTime, setStringStartTime] = useState("");
  const [openStringFixer, setOpenStringFixer] = useState(false);
  const [ErrorStrOnFocus, setErrorStrOnFocus] = useState(null);

  const [mergingLoading, setMergingLoading] = useState(false);
  const [formatProgress, setFormatProgress] = useState(false);
  const [teamAGK, setTeamAGK] = useState("");
  const [teamBGK, setTeamBGK] = useState("");

  const [proMode, setProMode] = useState(true);
  const [showSideChangeAlert, setShowSideChangeAlert] = useState(false);
  const [showSideChangeAlert2, setShowSideChangeAlert2] = useState(false);
  const [showBoxAlert, setShowBoxAlert] = useState(false);

  const [blockType, setBlockType] = useState("");

  const originalListRef = useRef();
  const history = useHistory();

  useEffect(() => {
    if (ErrorStrOnFocus && originalForFormating) {
      originalListRef.current.scrollToIndex({
        animated: true,
        index: ErrorStrOnFocus.index,
      });
    }
  }, [ErrorStrOnFocus]);

  useEffect(() => {
    if (width && height) {
      width > height ? setIsLandscape(true) : setIsLandscape(false);
    }
  }, [height, width]);

  // Mixpanel – track whenever analyst enters the tagging screen
  useEffect(() => {
    const eventCount = fullstringanalyse
      ? fullstringanalyse.split(',').filter((s) => s.trim() && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X').length
      : 0;
    trackEvent().track('entered_tagging_screen', { match_id: matchId, string_event_count: eventCount });
  }, []);

  useEffect(() => {
    fetchVideoTimeFromServer();
  }, []);

  const fetchVideoTimeFromServer = async () => {
    const fd = new FormData();
    fd.append("match_id", matchId);
    fd.append("analyst_id", props.analystId);
    const response = await axios.post(`${SSENSE_URL}get_match_video_data/`, fd);
    const data = await response.data;
    if (data) {
      const videoTimeStamp = data && data.video_timestamp;
      setVideoTimeFromServer(videoTimeStamp);
    }
  };

  useEffect(() => {
    if (props.matchString?.[matchId] && props.matchString?.[matchId] !== "") {
      if (props.matchString?.[matchId] !== fullstringanalyse) {
        setFullstringanalyse(props.matchString);
      }
    }
  }, [props.matchString]);

  useEffect(() => {
    if (fullstringanalyse !== "") {
      props.SetFullAnalyseString({ id: matchId, string: fullstringanalyse });
    }
  }, [fullstringanalyse]);

  useEffect(() => {
    const parse = (str) => {
      let stringArr = str.split(",");
      let lastString = stringArr[stringArr.length - 1];
      while (lastString === "X-X-X-X-X-X-X-X-X-X-X-X-X-X") {
        stringArr.pop();
        lastString = stringArr[stringArr.length - 1];
      }
      return stringArr.join(",");
    };
    const interval = setInterval(() => {
      if (
        fullstringanalyse !== "" &&
        fullstringanalyse !== "X-X-X-X-X-X-X-X-X-X-X-X-X-X"
      ) {
        const match_string = parse(fullstringanalyse);
        if (
          match_string !== "" &&
          match_string !== "X-X-X-X-X-X-X-X-X-X-X-X-X-X"
        ) {
          // Mixpanel – auto 90s push
          const autoEvents = match_string
            .split(',')
            .filter((s) => s.trim() && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X');
          trackEvent().track('push_match_string_auto', {
            match_id: matchId,
            string_event_count: autoEvents.length,
            string_char_length: match_string.length,
          });
          props.PushMatchStringToServer(
            matchId,
            props.analystId,
            match_string,
            props.token,
          );
        }
      }
    }, 90000);
    return () => clearInterval(interval);
  }, [fullstringanalyse]);
  // useEffect(() => {
  //   let cacheString
  //   const interval = setInterval(() => {
  //     if (fullstringanalyse !== "") {
  //       if (fullstringanalyse === cacheString) {
  //       } else {
  //         props.PushMatchStringToServer(
  //           matchId,
  //           props.analystId,
  //           fullstringanalyse,
  //           props.token
  //         )
  //         cacheString = fullstringanalyse
  //       }
  //     }
  //   }, 60000)
  //   return () => clearInterval(interval)
  // }, [fullstringanalyse])

  useEffect(() => {
    if (matchId && props.all_matches) {
      const details = props.all_matches?.find((m) => {
        return m.id.toString() === matchId;
      });
      details && setMatchDetails(details);
    }
  }, [matchId, props.all_matches]);

  useEffect(() => {
    if (matchDetails) {
      const teamA = matchDetails.team_a_details;
      const teamB = matchDetails.team_b_details;
      teamA && setTeamADetails(teamA);
      teamB && setTeamBDetails(teamB);
    }
  }, [matchDetails]);

  useEffect(() => {
    if (props.analysedata) {
      const teamA =
        props.analysedata.TeamInput &&
        props.analysedata.TeamInput[0].team_id &&
        props.analysedata.TeamInput[0].team_details;
      const teamB =
        props.analysedata.TeamInput &&
        props.analysedata.TeamInput[0].team_id &&
        props.analysedata.TeamInput[1].team_details;
      const teamAPlayerMap = teamA
        ? teamA.map((p) => {
          return p.jersey_number;
        })
        : [];
      const teamBPlayerMap = teamB
        ? teamB.map((p) => {
          return p.jersey_number;
        })
        : [];
      setTeamAPlayers(teamAPlayerMap);
      setTeamBPlayers(teamBPlayerMap);
    }
  }, [props.analysedata]);

  const TriggerDialog = (msg) => {
    // setShowDialog(msg);
    // setTimeout(() => {
    //   setShowDialog(null);
    // }, 1500);
    if (msg.color === "tomato") {
      toast.error(msg.msg);
    } else {
      toast.success(msg.msg);
    }
  };

  const FormatString = (string, result) => {
    setFormatProgress(true);
    var a = string;
    let b = a.split(",");
    let count = 0;
    let chckcount = 0;
    let original = [];
    let startTime = "";
    let lastTime = "";
    let den = [];
    let c = [];

    let actionnote;

    for (var i = 0; i < b.length; i++) {
      let c;
      c = b[i].split("-");
      actionnote = c[2] + "-" + c[3];
      switch (actionnote) {
        case "CS-4":
          if (i !== b.length - 1) {
            let nxtactionnote =
              b[i + 1].split("-")[2] + "-" + b[i + 1].split("-")[3];
            if (nxtactionnote !== "GS-0") {
              b[i] = b[i] + ",X-X-GS-0-" + c[5] + "-X-" + c[6] + "-X-X";
            }
          }
          break;
        case "LS-4":
          if (i !== b.length - 1) {
            let nxtactionnote =
              b[i + 1].split("-")[2] + "-" + b[i + 1].split("-")[3];
            if (nxtactionnote !== "GS-0") {
              b[i] = b[i] + ",X-X-GS-0-" + c[5] + "-X-" + c[6] + "-X-X";
            }
          }
          break;
        case "H-4":
          if (i !== b.length - 1) {
            let nxtactionnote =
              b[i + 1].split("-")[2] + "-" + b[i + 1].split("-")[3];
            if (nxtactionnote !== "GS-0") {
              b[i] = b[i] + ",X-X-GS-0-" + c[5] + "-X-" + c[6] + "-X-X";
            }
          }
          break;

        default:
          break;
      }
    }
    a = b.toString();
    b = a.split(",");
    c = [];

    for (let i = 0; i < b.length; i++) {
      let chck = b[i].split("-");

      if (chck[6] !== "X") {
        lastTime = chck[6];
        if (startTime === "") {
          startTime = chck[6];
        }
      }
      original.push({ index: i, str: b[i] });

      if (
        [
          "SP",
          "LP",
          "TB",
          "C",
          "PC",
          "CL",
          "GS",
          "XSP",
          "XLP",
          "XTB",
          "XC",
          "XPC",
          "XCL",
          "XGS",
        ].includes(chck[2])
      ) {
        if (["4"].includes(chck[3])) {
          den[chckcount] = { index: i, str: b[i] };
          chckcount++;
        } else {
          c[count] = { index: i, str: b[i] };
          count++;
        }
      }
      if (["T", "AD", "GD", "XDC", "XAD", "XGD"].includes(chck[2])) {
        if (["2", "3", "4"].includes(chck[3])) {
          den[chckcount] = { index: i, str: b[i] };
          chckcount++;
        } else {
          c[count] = { index: i, str: b[i] };
          count++;
        }
      }

      if (
        [
          "ST",
          "SL",
          "IN",
          "PR",
          "GH",
          "GT",
          "DR",
          "XST",
          "XSL",
          "XIN",
          "XPR",
          "XGH",
          "XGT",
          "XDR",
        ].includes(chck[2])
      ) {
        if (["3", "4"].includes(chck[3])) {
          den[chckcount] = { index: i, str: b[i] };
          chckcount++;
        } else {
          c[count] = { index: i, str: b[i] };
          count++;
        }
      }

      if (
        chck[2] !== "XCL" &&
        chck[2] !== "XPC" &&
        chck[2] !== "XH" &&
        chck[2] !== "X" &&
        chck[1] !== "X" &&
        chck[2] !== "XX" &&
        chck[2] !== "XGS" &&
        chck[2] !== "XGH" &&
        chck[2] !== "XLS" &&
        chck[2] !== "XCS" &&
        chck[2] !== "XDC" &&
        chck[2] !== "XOFF" &&
        chck[2] !== "XPC"
      ) {
        c[count] = { index: i, str: b[i] };
        count++;
      } else {
        den[chckcount] = { index: i, str: b[i] };
        chckcount++;
      }
    }
    a = c;

    let errstring = den;
    setFormatProgress(false);
    result({
      string: a,
      error: errstring,
      original,
      startTime: startTime,
      lastTime: lastTime,
    });
  };
  const handleFormatedString = (result) => {
    const { error, original, lastTime, startTime } = result;
    if (lastTime) {
      setStringLastTime(lastTime);
    }
    if (startTime) {
      setStringStartTime(startTime);
    }

    if (error?.length > 0) {
      setOpenStringFixer(true);
      setErrorStrings(error);
      TriggerDialog({ color: "tomato", msg: "ERROR DETECTED!" });
    } else {
      TriggerDialog({ msg: "GREAT ! NO ERROR!!" });
      openStringFixer && setOpenStringFixer(false);
    }
    if (original) {
      setOriginalForFormating(original);
      setFullstringanalyse(
        original
          .map((o) => o.str)
          .toString()
          .replaceAll(" ", "")
          .replaceAll(",,", ",")
          .replaceAll(",,,", ",")
          .replaceAll("\t", "")
          .replaceAll("\r", "")
          .replaceAll("\n", ""),
      );
    }
  };

  const gotoSubmitHandler = () => {
    FormatString(fullstringanalyse, handleFormatedString);
    if (errorStrings?.length > 0) {
      TriggerDialog({
        color: "tomato",
        msg: "ERROR DETECTED ! FORMAT & FIXED IT TO SUBMIT !!",
      });
    }
    if (
      originalForFormating &&
      originalForFormating.length > 0 &&
      (!errorStrings || errorStrings?.length === 0)
    ) {
      props.PushMatchStringToServer(
        matchId,
        props.analystId,
        fullstringanalyse,
        props.token,
      );
      history.push(`/matchupdate/${matchId}`);
    }
  };

  const mergeErrorToOriginal = () => {
    setErrorStrOnFocus(null);
    if (errorStrings?.length > 0 && originalForFormating?.length > 0) {
      setMergingLoading(true);
      const merged = originalForFormating?.map((s, i) => {
        const found = errorStrings?.find((e) => e.index === s.index);
        if (found) {
          const newError = errorStrings?.filter(
            (e) => e.index.toString() !== found?.index.toString(),
          );
          setErrorStrings(newError);

          return found;
        }
        return s;
      });
      if (merged?.length > 0) {
        const readyStr = merged.map((m) => m.str).toString();
        FormatString(readyStr, handleFormatedString);
        setMergingLoading(false);
      }
    }
  };

  const removeAllErrorFromOriginal = () => {
    let check = window.confirm(
      "This will removed ALL ERROR string. Comfirm ? ",
    );
    if (check) {
      const originalStrs = originalForFormating?.filter((i) => {
        if (errorStrings?.find((d) => d.index === i.index)) {
          return false;
        }
        return true;
      });
      setErrorStrings(null);
      originalStrs &&
        FormatString(
          originalStrs?.map((s) => s.str).toString(),
          handleFormatedString,
        );
    }
  };

  const openFormatterHanlder = () => {
    FormatString(fullstringanalyse, handleFormatedString);
  };

  const confirmSideChange = () => {
    setSecondHalf(!secondHalf);
    setShowSideChangeAlert(false);
    setShowSideChangeAlert2(true);
  };

  const cancelSideChange = () => {
    setShowSideChangeAlert(false);
  };

  const handleSideChange = () => {
    setShowSideChangeAlert(true);
    // if (changed) {
    //   setSecondHalf(!secondHalf);
    // }
  };

  if (screenfull.isEnabled) {
    screenfull.on("change", () => {
      setIsFullScreen(screenfull.isFullscreen);
      setIsModalOpen(true);
    });
  }

  const onDonePress = () => {
    // Mixpanel – Press Done After Tagging
    const lastStr = getLastEventString(
      fullstringanalyse || props.matchString?.[matchId]
    );
    const src = fullstringanalyse || props.matchString?.[matchId] || '';
    const eventCount = src
      ? src.split(',').filter((s) => s.trim() && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X').length
      : 0;
    trackEvent().track('pressed_done_after_tagging', {
      match_id: matchId,
      string_event_count: eventCount,
      ...(lastStr ? { last_event_string: lastStr } : {}),
    });

    if (isFullScreen) {
      screenfull.exit();
    }
  };

  const onCopyPress = (val) => {
    if (Clipboard.isAvailable) {
      if (props.matchString?.[matchId]) {
        const copied = Clipboard.setString(props.matchString?.[matchId]);
        if (copied) {
          TriggerDialog({ msg: "String Copied" });
        }
      }
    }
  };

  const onPastePress = async () => {
    // console.log("pressed")
    if (navigator.clipboard) {
      const pasted = await navigator.clipboard.readText();
      if (pasted) {
        let check = window.confirm(
          "This will replace the current analysed string. Comfirm ?",
        );
        if (check) {
          setFullstringanalyse(pasted);
          TriggerDialog({ msg: "String Pasted" });
        } else {
          return null;
        }
      } else {
        TriggerDialog({ msg: "No String Found", color: "tomato" });
      }
    }
  };

  const onSaveStringPress = async () => {
    if (props.matchString?.[matchId] !== "") {
      await props.PushMatchStringToServer(
        matchId,
        props.analystId,
        fullstringanalyse,
        props.token,
      );
      TriggerDialog("SAVED !!");
    }
  };

  const onLoadSaveStringPress = () => {
    // Mixpanel – Fetch Match String (record the current local string before replacing it)
    const lastStr = getLastEventString(
      fullstringanalyse || props.matchString?.[matchId]
    );
    const src = fullstringanalyse || props.matchString?.[matchId] || '';
    const eventCount = src
      ? src.split(',').filter((s) => s.trim() && s.trim() !== 'X-X-X-X-X-X-X-X-X-X-X-X-X-X').length
      : 0;
    trackEvent().track('fetch_match_string', {
      match_id: matchId,
      string_event_count: eventCount,
      ...(lastStr ? { last_event_string_before_fetch: lastStr } : {}),
    });

    const check =
      props.matchString?.[matchId] === ""
        ? true
        : window.confirm(
          "Fetch saved string from server. Are you sure? This will delete your current local string!"
        );
    check &&
      props.FetchMatchStringFromServer(matchId, props.analystId, props.token);
  };

  const onSharePress = async () => {
    if (props.matchString?.[matchId]) {
      try {
        const shareData = {
          title: `Analysed String for ${null}`,
          text: props.matchString?.[matchId],
        };

        await navigator.share(shareData);
      } catch (error) {
        alert(error);
      }
    }
  };

  const onClearPress = () => {
    if (props.matchString?.[matchId]) {
      const check = window.confirm(
        "Delete the analyse string. Are you sure? This will not delete the saved string in server !",
      );
      if (check) {
        setCurrAction("X-X-X-X-X-X-X-X-X-X-X-X-X-X");
        setSecondAction("X-X-X-X-X-X-X-X-X-X-X-X-X-X");
        setSecondActFlag(false);
        props.SetFullAnalyseString({ id: matchId, string: "" });
        setFullstringanalyse("");
      }
    }
  };

  const full = () => {
    if (!isIOS) {
      if (screenfull.isEnabled) {
        screenfull.request();
      }
    } else {
      if (navigator.userAgent.indexOf("iPhone") !== -1) {
        if (window.navigator.standalone) {
          setIsFullScreen(true);
          setIsModalOpen(true);
        } else {
          TriggerDialog({
            msg: "Please add the website to home screen to continue",
            color: "tomato",
          });
        }
      }
    }
  };

  const processElapsedTime = (seconds) => {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = ("0" + date.getUTCSeconds()).slice(-2);
    return `${hh}:${("0" + mm).slice(-2)}:${ss}`;
  };

  //player press handler
  const playerPress = (jNumber, teamAnnot) => {
    const validSecondPositions = new Set([
      "SP",
      "LP",
      "C",
      "TB",
      "CS",
      "LS",
      "H",
      "PC",
    ]);
    if (teamAGK === "" || teamBGK === "") {
      TriggerDialog({
        msg: "Please fill the Goalkeeper Jerseys for both the teams",
        color: "tomato",
      });
    } else {
      var a = currAction;
      var b = a.split("-");
      var team = b[0];
      var jersey = b[1];
      var action = b[2];
      var notate = b[3];
      var time = b[6];
      var firstpos = b[4];
      var secndpos = b[5];
      if (
        (team === "X" ||
          jersey === "X" ||
          action === "X" ||
          notate === "X" ||
          time === "X" ||
          firstpos === "X") &&
        currAction !== "X-X-X-X-X-X-X-X-X-X-X-X-X-X" &&
        proMode
      ) {
        TriggerDialog({ msg: "Please complete the flow", color: "tomato" });
      } else if (validSecondPositions.has(action) && secndpos === "X") {
        TriggerDialog({
          msg: "Please select the second position",
          color: "tomato",
        });
      } else {
        var playerjersey = teamAnnot + "-" + jNumber;
        if (secActFlag === false) {
          fetchVideoTimeFromServer();
          var paction = currAction;
          var gkaction = "";
          if (action === "LS" || action === "CS" || action === "H") {
            var secndps = 80 - parseInt(secndpos) + 1;
            var mStartCoordx1 = 120 - parseInt(startCoordx1) + 1;

            var mStartCoordy1 = 120 - parseInt(startCoordy1) + 1;

            var mStartCoordx2 = 120 - parseInt(startCoordx2) + 1;

            var mStartCoordy2 = 120 - parseInt(startCoordy2) + 1;
            if (notate === "1") {
              if (team === "A") {
                gkaction =
                  ",B-" +
                  teamBGK +
                  "-GS-1-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  mStartCoordx1 +
                  "-" +
                  mStartCoordx2 +
                  "-" +
                  mStartCoordy1 +
                  "-" +
                  mStartCoordy2;
              } else if (team === "B") {
                gkaction =
                  ",A-" +
                  teamAGK +
                  "-GS-1-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  mStartCoordx1 +
                  "-" +
                  mStartCoordx2 +
                  "-" +
                  mStartCoordy1 +
                  "-" +
                  mStartCoordy2;
              }
            } else if (notate === "4") {
              if (team === "A") {
                gkaction =
                  ",B-" +
                  teamBGK +
                  "-GS-0-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  mStartCoordx1 +
                  "-" +
                  mStartCoordx2 +
                  "-" +
                  mStartCoordy1 +
                  "-" +
                  mStartCoordy2;
              } else if (team === "B") {
                gkaction =
                  ",A-" +
                  teamAGK +
                  "-GS-0-" +
                  secndps +
                  "-X-" +
                  time +
                  "-X-X-" +
                  halfTag +
                  "-" +
                  mStartCoordx1 +
                  "-" +
                  mStartCoordx2 +
                  "-" +
                  mStartCoordy1 +
                  "-" +
                  mStartCoordy2;
              }
            }
          }
          var fulstring;
          if (playerSelect !== "X-X") {
            if (secondAction !== "X-X-X-X-X-X-X-X-X-X-X-X-X-X") {
              fulstring = fullstringanalyse
                ? fullstringanalyse +
                "," +
                paction +
                "," +
                secondAction +
                gkaction
                : paction + "," + secondAction + gkaction;
              if (gkaction !== "") {
                TriggerDialog({
                  msg: "Goal Keeper Action :" + gkaction + " added to string!",
                  color: "Green",
                });
              }
            } else {
              fulstring = fullstringanalyse + "," + paction + gkaction;
              if (gkaction !== "") {
                TriggerDialog({
                  msg: "Goal Keeper Action :" + gkaction + " added to string!",
                  color: "Green",
                });
              }
            }
          } else {
            fulstring = fullstringanalyse;
          }
          var crpos = playerjersey + "-X-X-X-X-X-X-X-" + halfTag;
          setPlayerSelect(playerjersey);
          setStartPos("X");
          setEndPos("X");
          setActionAttrib("X");
          setNotate("X");
          setPrevAction(paction);
          setCurrAction(crpos);
          setSecondAction("X-X-X-X-X-X-X-X-X-X-X-X-X-X");
          setSecondActFlag(true);
          setFullstringanalyse(fulstring);
        } else {
          var secondpos;
          var secStartCoordx1;
          var secStartCoordy1;

          if (endPos !== "X") {
            secondpos = endPos;
            secStartCoordx1 = startCoordx2;
            secStartCoordy1 = startCoordy2;
          } else {
            secondpos = startPos;
            secStartCoordx1 = startCoordx1;
            secStartCoordy1 = startCoordy1;
          }
          if (
            currAction.charAt(0) !== playerjersey.charAt(0) &&
            secondpos !== "X"
          ) {
            secondpos = 80 - parseInt(secondpos) + 1;
            secStartCoordx1 = 120 - parseInt(secStartCoordx1) + 1;
            secStartCoordy1 = 120 - parseInt(secStartCoordy1) + 1;
          }
          var secAttr =
            playerjersey +
            "-X" +
            actionAttrib +
            "-" +
            notate +
            "-" +
            secondpos +
            "-X-" +
            processElapsedTime(videoTimeFromServer) +
            "-X-X-" +
            halfTag +
            "-" +
            secStartCoordx1 +
            "-" +
            secStartCoordy1 +
            "-X-X";
          if (actionAttrib === "AD" || actionAttrib === "GD") {
            var initplyr = currAction.substr(0, currAction.indexOf("-", 2));
            var additionact =
              playerjersey +
              "-" +
              actionAttrib +
              "-0-" +
              (80 - startPos + 1) +
              "-X-" +
              processElapsedTime(videoTimeFromServer) +
              "-X-X-" +
              halfTag +
              "," +
              initplyr +
              "-X" +
              actionAttrib +
              "-0-" +
              startPos +
              "-X-" +
              processElapsedTime(videoTimeFromServer) +
              "-X-X-" +
              halfTag +
              "-" +
              (120 - startCoordx1 + 1) +
              "-" +
              (120 - startCoordy1 + 1) +
              "-" +
              (120 - startCoordx2 + 1) +
              "-" +
              (120 - startCoordy2 + 1);
            secAttr = secAttr + "," + additionact;
          }

          var errorPlayer = 0;
          // receiver team validation based on action type
          if (actionAttrib === "DL") {
            // direct link must have receiver on opposite team
            if (currAction.charAt(0) === playerjersey.charAt(0)) {
              errorPlayer = 1;
            }
          } else if (
            (actionAttrib === "SP" ||
              actionAttrib === "LP" ||
              actionAttrib === "TB" ||
              actionAttrib === "C" ||
              actionAttrib === "GT") &&
            currAction.charAt(0) !== playerjersey.charAt(0)
          ) {
            errorPlayer = 1;
          } else if (
            (actionAttrib === "ST" ||
              actionAttrib === "SL" ||
              actionAttrib === "IN" ||
              actionAttrib === "DR" ||
              actionAttrib === "AD" ||
              actionAttrib === "GD" ||
              actionAttrib === "PR") &&
            currAction.charAt(0) === playerjersey.charAt(0)
          ) {
            errorPlayer = 1;
          }

          if (errorPlayer === 0) {
            setSecondAction(secAttr);
            props.AddToActionLog({ mode: "r", str: secAttr });
            props.SetCurrentAction(secAttr);
            setSecondActFlag(false);
          } else {
            TriggerDialog({
              msg: "Please select the correct team player",
              color: "tomato",
            });
          }
        }
      }
    }
  };

  const onFieldPress = (position, xy_coordinate) => {
    // console.log("new coordinate -->", xy_coordinate);

    // if current action is DL, ensure both positions known before allowing any change
    if (currAction.split("-")[2] === "DL" && (startPos === "X" || endPos === "X")) {
      TriggerDialog({
        msg: "Both start and end positions are required for DL",
        color: "tomato",
      });
      return;
    }

    const validSecondPositions = new Set([
      "SP",
      "LP",
      "C",
      "TB",
      "CS",
      "LS",
      "H",
      "PC",
    ]);
    var pos = position;
    var coordx = xy_coordinate.x;
    var coordy = xy_coordinate.y;
    var criticalzone = [
      11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43, 51, 52, 53, 61, 62, 63,
    ];
    var flankzone = [
      1, 2, 3, 4, 11, 12, 13, 14, 61, 62, 63, 64, 71, 72, 73, 74,
    ];
    var pboxzone = [21, 22, 31, 32, 41, 42, 51, 52];
    var jersey_no = playerSelect;
    var team_nm = jersey_no.substring(0, 1);
    var secndhalf = secondHalf;
    var a = currAction;
    var b = a.split("-");
    var team = b[0];
    var jersey = b[1];
    var action = b[2];
    var notate = b[3];
    var time = b[6];
    var firstpos = b[4];
    const secondpos = b[5];
    var att = "X",
      nottn = "X",
      hfoot = "R";
    if (secndhalf === false) {
      if (team_nm === "A") {
        pos = 80 - parseInt(position) + 1;
        coordx = 120 - parseInt(xy_coordinate.x) + 1;
        coordy = 120 - parseInt(xy_coordinate.y) + 1;
      }
    } else {
      if (team_nm === "B") {
        pos = 80 - parseInt(position) + 1;
        coordx = 120 - parseInt(coordx) + 1;
        coordy = 120 - parseInt(coordy) + 1;
      }
    }
    var crpos;

    if (startPos === "X") {
      crpos =
        playerSelect +
        "-" +
        actionAttrib +
        "-" +
        notate +
        "-" +
        pos +
        "-" +
        endPos +
        "-X-X-X-" +
        halfTag +
        "-" +
        coordx +
        "-" +
        coordy +
        "-X-X";
      setStartPos(pos);
      setStartCoordx1(coordx);
      setStartCoordy1(coordy);
      setStartCoordx2("X");
      setStartCoordy2("X");
      setCurrAction(crpos);
    } else if (endPos === "X" && actionAttrib === "X") {
      var mainstpos = parseInt(startPos);
      var mainenpos = parseInt(pos);

      const passClassification = classifyPassType(mainstpos, mainenpos);
      att = passClassification.type;
      nottn = passClassification.notation;
      crpos =
        playerSelect +
        "-" +
        att +
        "-" +
        nottn +
        "-" +
        startPos +
        "-" +
        pos +
        "-" +
        processElapsedTime(videoTimeFromServer) +
        "-" +
        hfoot +
        "-X-" +
        halfTag +
        "-" +
        startCoordx1 +
        "-" +
        startCoordy1 +
        "-" +
        coordx +
        "-" +
        coordy;
      setEndPos(pos);
      setStartCoordx2(coordx);
      setStartCoordy2(coordy);
      setCurrAction(crpos);
      setActionAttrib(att);
      setNotate(nottn);
    } else if (
      startPos !== "X" &&
      playerSelect !== "X-X" &&
      actionAttrib !== "X" &&
      proMode
    ) {
      if (
        (team === "X" ||
          jersey === "X" ||
          action === "X" ||
          notate === "X" ||
          time === "X" ||
          firstpos === "X") &&
        proMode
      ) {
        TriggerDialog({ msg: "Please complete the flow", color: "tomato" });
      } else {
        if (validSecondPositions.has(action) && secondpos === "X") {
          TriggerDialog({
            msg: "Please select the second position",
            color: "tomato",
          });
        } else {
          var secndactn = secondAction;
          crpos =
            playerSelect +
            "-X-X-" +
            pos +
            "-X-X-X-X-" +
            halfTag +
            "-" +
            startCoordx1 +
            "-" +
            startCoordy1 +
            "-" +
            startCoordx2 +
            "-" +
            startCoordy2;
          var paction = currAction;
          var fulstring;
          if (playerSelect !== "X-X") {
            if (secondAction !== "X-X-X-X-X-X-X-X-X-X-X-X-X-X") {
              fulstring =
                fullstringanalyse + "," + paction + "," + secondAction;
              secndactn = "X-X-X-X-X-X-X-X-X-X-X-X-X-X";
            } else {
              fulstring = fullstringanalyse + "," + paction;
            }
          } else {
            fulstring = fullstringanalyse;
          }
          setStartPos(pos);
          setEndPos("X");
          setActionAttrib("X");
          setNotate("X");
          setCurrAction(crpos);
          setPrevAction(paction);
          setSecondActFlag(true);
          setFullstringanalyse(fulstring);
          setSecondAction(secndactn);
          setStartCoordx1(coordx);
          setStartCoordy1(coordy);
        }
      }
    } else {
      TriggerDialog({ msg: "Please complete the flow", color: "tomato" });
    }
  };

  //Half Tagging handler
  const onHalfTag = (key) => {
    switch (key) {
      case "FHN":
        setHalfTag("FHI");
        break;
      case "FHI":
        setHalfTag("SHN");
        break;
      case "SHN":
        setHalfTag("SHI");
        break;
      case "SHI":
        setHalfTag("ET1N");
        break;
      case "ET1N":
        setHalfTag("ET1I");
        break;
      case "ET1I":
        setHalfTag("ET2N");
        break;
      case "ET2N":
        setHalfTag("ET2I");
        break;
      case "ET2I":
        setHalfTag("PK");
        break;
      case "PK":
        setHalfTag("FHN");
        break;
    }
  };

  //key press handler
  const onKeyPress = (key) => {
    if (
      key === "G" &&
      !["LP", "SP", "TB"].includes(currAction?.split("-")?.[2])
    ) {

      toast.error("G can only be tagged for Passing.");
      return;
    }
    key = key + "";

    // // disable notation 2, 3 and 4 when direct link is active
    // if ((key !== "1") && actionAttrib === "DL") {
    //   TriggerDialog({
    //     msg: "Notation 1 is only allowed for DL",
    //     color: "tomato",
    //   });
    //   return;
    // }

    const arr = fullstringanalyse?.split(",");

    var stpos, enpos, jerseyno, teamnm, sechaf;
    stpos = parseInt(startPos);
    enpos = endPos === "X" ? "X" : parseInt(endPos);
    jerseyno = playerSelect;
    teamnm = jerseyno.substring(0, 1);
    var defcriticalzone = [
      18, 19, 20, 28, 29, 30, 38, 39, 40, 48, 49, 50, 58, 59, 60, 68, 69, 70,
    ];
    var criticalzone = [
      11, 12, 13, 21, 22, 23, 31, 32, 33, 41, 42, 43, 51, 52, 53, 61, 62, 63,
    ];
    var flankzone = [
      1, 2, 3, 4, 11, 12, 13, 14, 61, 62, 63, 64, 71, 72, 73, 74,
    ];
    var pboxzone = [21, 22, 31, 32, 41, 42, 51, 52];
    var mainstpos, mainenpos;
    var att = "X",
      nottn = "X",
      speclact = "X",
      hfoot = "R";
    var prevact = prevAction;
    switch (key) {
      case "BACK SPACE":
        var ex = "X";
        var exes = "X-X";
        var multiex = "X-X-X-X-X-X-X-X-X-X-X-X-X-X";
        att = "X";
        nottn = "X";
        hfoot = "X";
        setStartPos(ex);
        setEndPos(ex);
        setPlayerSelect(exes);
        setActionAttrib(ex);
        setNotate(ex);
        setCurrAction(multiex);
        setSecondAction(multiex);
        setSecondActFlag(false);
        setElapseTime(ex);
        setSpecialAction(ex);
        setActFoot(ex);
        setStartCoordx1(ex);
        setStartCoordy1(ex);
        setStartCoordx2(ex);
        setStartCoordy2(ex);

        break;
      case "X":
        att = actionAttrib;
        nottn = "0";
        break;
      case "0":
        att = actionAttrib;
        nottn = "0";
        break;
      case "1":
        att = actionAttrib;
        nottn = "1";
        break;
      case "2":
        att = actionAttrib;
        nottn = "2";
        break;
      case "3":
        att = actionAttrib;
        nottn = "3";
        break;
      case "4":
        att = actionAttrib;
        nottn = "4";
        break;
      case "IN":
        mainenpos = enpos;
        mainstpos = stpos;
        att = "IN";

        if (defcriticalzone.indexOf(mainstpos) === -1) {
          nottn = "1";
        } else {
          nottn = "2";
        }
        break;
      case "PS":
        mainstpos = stpos;
        mainenpos = enpos;

        const passClassification = classifyPassType(mainstpos, mainenpos, true);
        att = passClassification.type;
        nottn = passClassification.notation;

        break;
      case "SP":
        att = "SP";
        nottn = "1";
        break;
      case "LP":
        att = "LP";
        nottn = "1";
        break;
      case "C":
        att = "C";
        nottn = "1";
        break;
      case "DR":
        mainstpos = stpos;
        mainenpos = "X";

        att = "DR";
        if (criticalzone.indexOf(mainstpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }
        break;
      case "AD":
        mainstpos = stpos;
        mainenpos = "X";

        att = "AD";
        if (defcriticalzone.indexOf(stpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }

        break;
      case "GD":
        mainstpos = stpos;
        mainenpos = "X";

        att = "GD";
        if (defcriticalzone.indexOf(stpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }

        break;
      case "CL":
        mainenpos = enpos;
        mainstpos = stpos;
        att = "CL";

        if (mainstpos === 40 || mainstpos === 50) {
          nottn = "3";
        } else if (
          mainstpos === 29 ||
          mainstpos === 30 ||
          mainstpos === 39 ||
          mainstpos === 49 ||
          mainstpos === 59 ||
          mainstpos === 60
        ) {
          nottn = "2";
        } else {
          nottn = "1";
        }
        break;
      case "TB":
        att = "TB";

        mainstpos = stpos;
        mainenpos = enpos;
        if (pboxzone.indexOf(mainenpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }
        break;
      case "T":
        mainenpos = "X";
        mainstpos = stpos;
        att = "T";
        nottn = "1";
        break;
      case "PC":
        att = "PC";

        mainstpos = stpos;
        mainenpos = enpos;
        if (
          mainstpos === mainenpos ||
          mainstpos + 1 === mainenpos ||
          mainstpos - 1 === mainenpos ||
          mainstpos + 11 === mainenpos ||
          mainstpos + 10 === mainenpos ||
          mainstpos + 9 === mainenpos ||
          mainstpos - 10 === mainenpos ||
          mainstpos - 9 === mainenpos ||
          mainstpos - 11 === mainenpos
        ) {
          nottn = "1";
        } else if (
          mainstpos + 2 === mainenpos ||
          mainstpos - 2 === mainenpos ||
          mainstpos + 12 === mainenpos ||
          mainstpos + 20 === mainenpos ||
          mainstpos + 19 === mainenpos ||
          mainstpos - 20 === mainenpos ||
          mainstpos - 19 === mainenpos ||
          mainstpos - 12 === mainenpos ||
          mainstpos - 22 === mainenpos ||
          mainstpos + 22 === mainenpos ||
          mainstpos - 18 === mainenpos ||
          mainstpos + 18 === mainenpos ||
          mainstpos - 21 === mainenpos ||
          mainstpos + 21 === mainenpos ||
          mainstpos - 8 === mainenpos ||
          mainstpos + 8 === mainenpos
        ) {
          nottn = "2";
        } else {
          nottn = "3";
        }

        break;
      case "GS":
        att = "GS";
        nottn = "1";

        break;
      case "GT":
        att = "GT";
        nottn = "1";

        break;
      case "GH":
        att = "GH";
        nottn = "1";
        break;
      case "ST":
        att = "ST";
        if (defcriticalzone.indexOf(stpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }

        break;
      case "SHT":
        //TODO: IMPLEMENT PASS ANALYZER
        const _arr = ",";
        let currSHT = currAction.split("-");
        if (pboxzone.indexOf(stpos) !== -1) {
          att = "CS";
          currSHT[2] = "CS";
        } else {
          att = "LS";
          currSHT[2] = "LS";
        }
        nottn = "1";
        currSHT = currSHT.join("-");
        const error = passAnalyzer(currSHT, _arr.length - 1, _arr);
        if (error) {
          TriggerDialog({
            msg: error,
            color: "tomato",
          });
        }
        break;
      case "CS":
        att = "CS";
        nottn = "1";
        break;
      case "LS":
        att = "LS";
        nottn = "1";
        break;
      case "H":
        att = "H";
        nottn = "1";
        break;
      case "SL":
        att = "SL";
        if (defcriticalzone.indexOf(stpos) !== -1) {
          nottn = "2";
        } else {
          nottn = "1";
        }

        break;

      // Type 1 setting =======================================================

      case "PR":
        att = "PR";
        nottn = "1";
        break;
      case "OFF":
        att = "OFF";
        nottn = "1";
        break;
      case "THW":
        att = "THW";
        nottn = "1";
        break;
      case "DL":
        att = "DL";
        nottn = "1";
        break;
      case "HB":
        att = "HB";
        nottn = "1";
        break;
      case "L":
        att = actionAttrib;
        nottn = notate;
        hfoot = "L";
        speclact = specialAction;
        break;

      // Type 2 and 4 setting ================================

      case "CN":
        att = actionAttrib;
        nottn = notate;
        speclact = "CN";
        break;
      case "FK":
        //TODO: freeKickAnalyzerHelper
        let currFk = currAction.split("-");
        att = actionAttrib;
        nottn = notate;
        speclact = "FK";
        currFk[8] = speclact;
        currFk = currFk.join("-");
        const fkError = freeKickAnalyzer(currFk, arr.length - 1, arr);
        if (fkError) {
          setShowBoxAlert(true);
        }
        break;
      case "PK":
        //TODO: freeKickAnalyzerHelper
        att = actionAttrib;
        nottn = notate;
        speclact = "PK";
        let currPk = currAction.split("-");
        currPk[8] = speclact;
        currPk = currPk.join("-");
        const pkError = freeKickAnalyzer(currPk, arr.length - 1, arr);
        if (pkError) {
          setShowBoxAlert(true);
        }
        break;
      case "F":
        att = actionAttrib;
        nottn = notate;
        speclact = "F";
        break;
      case "RC":
        att = actionAttrib;
        nottn = notate;
        speclact = "RC";
        break;
      case "YC":
        att = actionAttrib;
        nottn = notate;
        speclact = "YC";
        break;
      case "GK":
        att = actionAttrib;
        nottn = notate;
        speclact = "GK";
        break;
      case "OG":
        att = actionAttrib;
        nottn = notate;
        speclact = "OG";
        break;
      default:
        break;
    }
    if (key !== "BACK SPACE") {
      var crpos =
        playerSelect +
        "-" +
        att +
        "-" +
        nottn +
        "-" +
        startPos +
        "-" +
        endPos +
        "-" +
        processElapsedTime(videoTimeFromServer) +
        "-" +
        hfoot +
        "-" +
        speclact +
        "-" +
        halfTag +
        "-" +
        startCoordx1 +
        "-" +
        startCoordy1 +
        "-" +
        startCoordx2 +
        "-" +
        startCoordy2;
    } else {
      crpos = "X-X-X-X-X-X-X-X-X-X-X-X-X-X";
    }
    var secondpos;
    if (endPos !== "X") {
      secondpos = endPos;
    } else {
      secondpos = startPos;
    }

    var secattri = "X-X-X" + att + "-" + nottn + "-" + secondpos + "-X-X-X-X";

    setActionAttrib(att);
    setNotate(nottn);
    setCurrAction(crpos);
    setSpecialAction(speclact);
    setActFoot(hfoot);
    props.SetCurrentAction(crpos);
    key !== "BACK SPACE" && props.AddToActionLog({ mode: "p", str: crpos });
  };
  // next press handler
  const onNextPress = () => {
    var a = currAction;
    var b = a.split("-");
    var team = b[0];
    var jersey = b[1];
    var action = b[2];
    var notate = b[3];
    var time = b[6];
    var firstpos = b[4];
    var secndpos = b[5];
    // both positions required for DL
    if ((firstpos === "X" || secndpos === "X") && action === "DL") {
      TriggerDialog({
        msg: "Both start and end positions are required for DL",
        color: "tomato",
      });
      return;
    }

    if (
      (action === "SP" ||
        action === "LP" ||
        action === "C" ||
        action === "TB" ||
        action === "GT" ||
        action === "ST" ||
        action === "SL" ||
        action === "IN" ||
        action === "DR" ||
        action === "AD" ||
        action === "GD" ||
        action === "PR") &&
      notate > 0
    ) {
      TriggerDialog({
        msg: "Please select the receiving player jersey",
        color: "tomato",
      });
    } else {
      setSecondActFlag(false);
    }
  };

  //RENDER START
  if (closeRequested) {
    return (
      <View
        style={{
          flex: 1,
          padding: 20,
          backgroundColor: "#fff",
          width: "100%",
          height: "100%",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: width / 100 }}>CLOSING CONTROLLER WINDOW</Text>
        <ActivityIndicator />
      </View>
    );
  }

  if (!width) {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#131313",
          zIndex: 1,
        }}
        onLayout={(e) => {
          setWidth(e.nativeEvent.layout.width);
          setHeight(e.nativeEvent.layout.height);
        }}
      >
        <ActivityIndicator />
        <Text style={{ color: "#fff", marginTop: 10 }}>One Sec...</Text>
      </View>
    );
  }

  return (
    <View
      style={styles.container}
      onLayout={(e) => {
        setWidth(e.nativeEvent.layout.width);
        setHeight(e.nativeEvent.layout.height);
      }}
    >
      {/* <dialog
        open={isFullScreen}
        style={{
          backgroundColor: showDialog?.color || "green",
          zIndex: 999,
          position: "fixed",
          inset: 0,
          padding: 15,
          paddingHorizontal: 10,
          borderWidth: 0,
          fontWeight: "700",
          fontSize: 14,
          color: "#fff",
          boxShadow: "0px 3px 6px #00000090",
          width: "60vw",
          height: "60vh",
          // placeItems: "center",
        }}
      >
        "hello"
      </dialog> */}
      <ReactModal
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setIsModalOpen(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(5px)",
          },
          content: {
            backgroundColor: "#fff",
            width: 400,
            height: 150,
            border: "none",
            inset: "auto",
            padding: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.6rem",
          },
        }}
      >
        <p style={{ fontWeight: "bold", fontSize: 17, textAlign: "center" }}>
          Please provide the GK jersey no in the corresponding fields. Please
          select the proper Half Tag "FHN/SHN" before analysis.
        </p>
      </ReactModal>
      {openStringFixer && (
        <View
          style={{
            width: "100%",
            height: "100%",
            margin: -5,
            overflow: "auto",
            position: "absolute",
            flexDirection: isLandscape ? "row" : "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#e1e1e1",
            zIndex: 6,
          }}
        >
          <View
            style={{
              flex: 1,
              height: "100%",
              padding: 5,
              width: "90%",
            }}
          >
            <Text
              style={{
                fontFamily: "Poppins",
                fontSize: 10,
                fontWeight: "700",
                color: "#21212e",
              }}
            >
              Error Strings ( Tap to EDIT )
            </Text>
            <FlatList
              data={errorStrings}
              extraData={errorStrings}
              keyExtractor={(item) => item.index.toString()}
              style={{
                backgroundColor: "#e1e1e1",
                elevation: 8,
              }}
              renderItem={({ item }) => {
                const handleDelete = () => {
                  let check = window.confirm(
                    "This will removed the error string. Comfirm ? ",
                  );
                  if (check) {
                    const tempStrs = errorStrings?.filter((i) => {
                      return i.index !== item.index;
                    });
                    const originalStrs = originalForFormating?.filter((i) => {
                      return i.index !== item.index;
                    });
                    setErrorStrings(tempStrs);
                    originalStrs &&
                      FormatString(
                        originalStrs.map((s) => s.str).toString(),
                        handleFormatedString,
                      );
                  }
                };
                const changeStrHandler = (text) => {
                  if (text !== "") {
                    const tempStrs = errorStrings.map((i) => {
                      if (i.index === item.index) {
                        return { index: i.index, str: text };
                      }
                      return i;
                    });
                    setErrorStrings(tempStrs);
                  }
                };

                return (
                  <View
                    style={{
                      widthy: "100%",
                      height: 30,
                      backgroundColor: "#fff",
                      marginVertical: 2,
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 2,
                    }}
                  >
                    <TextInput
                      onFocus={() => {
                        setErrorStrOnFocus(item);
                      }}
                      onChangeText={changeStrHandler}
                      style={{ flex: 1 }}
                      value={item.str}
                    />
                    <FaTrash onClick={handleDelete} />
                  </View>
                );
              }}
            />
          </View>
          <View
            style={{
              flex: 0.5,
              height: "100%",
              backgroundColor: "#e1e1e1",
              flexDirection: isLandscape ? "column" : "row",
              justifyContent: "space-evenly",
            }}
          >
            <View>
              {stringLastTime && (
                <View
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 5,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 10,
                      color: "#616161",
                    }}
                  >
                    Last Action Time
                  </Text>
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      fontWeight: "700",
                      color: "#131313",
                    }}
                  >
                    {stringLastTime}
                  </Text>
                </View>
              )}
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 5,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 10,
                    color: "#616161",
                  }}
                >
                  Total
                </Text>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                  }}
                >
                  {originalForFormating?.length}
                </Text>
              </View>
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 5,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 10,
                    color: "tomato",
                  }}
                >
                  Total Error
                </Text>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                  }}
                >
                  {errorStrings?.length || "0"}
                </Text>
              </View>
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: 5,
                  paddingBottom: 0,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 10,
                    color: "tomato",
                    textAlign: "center",
                  }}
                >
                  With Timestamp
                </Text>
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                  }}
                >
                  {
                    errorStrings?.filter((e) => {
                      let chck = e.str?.split("-");
                      if (chck[6] !== "X") {
                        return true;
                      }
                    })?.length
                  }
                </Text>
              </View>
            </View>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                padding: 5,
              }}
            >
              <TouchableOpacity
                disabled={mergingLoading}
                onPress={mergeErrorToOriginal}
                style={{
                  padding: 5,
                  backgroundColor: "#00A2DF",
                  flexDirection: "row",
                  elevation: 8,
                }}
              >
                <FaForward color="#fff" />
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#fff",
                    paddingLeft: 2,
                  }}
                >
                  MERGE
                </Text>
                {mergingLoading && (
                  <View
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#ffffff60",
                      borderRadius: 2,
                      justifyContent: "center",
                      position: "absolute",
                      zIndex: 5,
                      alignItems: "center",
                    }}
                  >
                    <ActivityIndicator />
                  </View>
                )}
              </TouchableOpacity>
            </View>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                padding: 5,
              }}
            >
              <TouchableOpacity
                onPress={removeAllErrorFromOriginal}
                style={{
                  padding: 5,
                  borderRadius: 2,
                  borderWidth: 1,
                  backgroundColor: "orange",
                  flexDirection: "row",
                  elevation: 8,
                }}
              >
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 9,
                    fontWeight: "700",
                    color: "#131313",
                    paddingLeft: 2,
                    textAlign: "center",
                  }}
                >
                  DISCARD ALL ERRORS
                </Text>
              </TouchableOpacity>
            </View>
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                padding: 5,
              }}
            >
              <TouchableOpacity
                onPress={() => setOpenStringFixer(false)}
                style={{
                  padding: 5,
                  borderRadius: 2,
                  borderWidth: 1,
                  borderColor: "tomato",
                  flexDirection: "row",
                  elevation: 8,
                }}
              >
                <FaWindowClose color="#131313" />
                <Text
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    fontWeight: "700",
                    color: "#131313",
                    paddingLeft: 2,
                  }}
                >
                  CLOSE
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              flex: 1,
              height: "100%",
              padding: 5,
              width: "100%",
            }}
          >
            <Text
              style={{
                fontFamily: "Poppins",
                fontSize: 10,
                fontWeight: "700",
                width: "100%",
                textAlign: "right",
                color: "#21212e",
              }}
            >
              Analysed Strings
            </Text>
            <FlatList
              ref={originalListRef}
              style={{ backgroundColor: "#fff", paddingLeft: 5 }}
              keyExtractor={(item) => item.index.toString()}
              getItemLayout={(data, index) => ({
                length: 12,
                offset: 12 * index,
                index,
              })}
              data={originalForFormating}
              extraData={originalForFormating}
              removeClippedSubviews
              renderItem={({ item }) => {
                return (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor:
                        ErrorStrOnFocus?.index === item.index && "lime",
                    }}
                  >
                    <Text style={{ fontFamily: "Poppins", fontSize: 9 }}>
                      {item.str}
                    </Text>
                  </View>
                );
              }}
            />
          </View>
        </View>
      )}
      {!isLandscape ? (
        <View
          style={{
            width: "100%",
            height: "100%",
            margin: -5,
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#131313",
            zIndex: 5,
          }}
        >
          <Logo size={18} />
          <Text
            style={{
              color: "#fff",
              fontSize: "1em",
              padding: 10,
              marginTop: 5,
            }}
          >
            ANALYST CONTROLLER
          </Text>
          <View
            style={{
              flexDirection: props.matchString?.[matchId] ? "row" : "column",
              justifyContent: "center",
              alignItems: "center",
              marginVertical: 5,
            }}
          >
            <Text
              style={{
                fontSize: 12,
                color: "#131313",
                backgroundColor: "#e1e1e190",
                padding: 5,
              }}
            >
              ANALYST ID : {props.analystId}
            </Text>
            <Text
              style={{
                fontSize: 12,
                color: "#131313",
                backgroundColor: "#e1e1e190",
                padding: 5,
                margin: 2,
              }}
            >
              MATCH ID : {matchId}
            </Text>
          </View>

          {props.matchString?.[matchId] ? (
            <View>
              <Text
                style={{
                  color: "#dddddd",
                  textAlign: "center",
                  width: "100%",
                  fontSize: 12,
                }}
              >
                Analysed String
              </Text>
              <TextInput
                editable={false}
                style={{
                  color: "#fff",
                  borderWidth: 1,
                  borderColor: "#e1e1e1",
                  padding: 5,
                }}
                value={props.matchString?.[matchId]}
              />
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  style={{
                    padding: 10,
                    marginTop: 20,
                    fontSize: width / 50,
                    marginRight: 5,
                    fontWeight: "700",
                    borderWidth: 0,
                    backgroundColor: "tomato",
                    borderRadius: 2,
                  }}
                  onClick={onClearPress}
                >
                  <FaTrash /> CLEAR STRING
                </button>
                <button
                  style={{
                    padding: 10,
                    marginTop: 20,
                    fontSize: width / 50,
                    marginHorizontal: 10,
                    fontWeight: "700",
                    borderWidth: 0,
                    backgroundColor: "green",
                    borderRadius: 2,
                    color: "#fff",
                  }}
                  onClick={onCopyPress}
                >
                  <FaCopy /> COPY STRING
                </button>
                <button
                  style={{
                    padding: 10,
                    marginTop: 20,
                    fontSize: width / 50,
                    borderWidth: 0,
                    fontWeight: "700",
                    marginLeft: 5,
                    backgroundColor: "#00bbee",
                    color: "#fff",
                    borderRadius: 2,
                  }}
                  onClick={onSharePress}
                >
                  <FaShare /> SHARE STRING
                </button>
              </View>
              <button
                style={{
                  padding: 10,
                  marginTop: 20,
                  fontSize: width / 50,
                  marginRight: 5,
                  fontWeight: "700",
                  borderWidth: 0,
                  backgroundColor: "#e1e1e1",
                  borderRadius: 2,
                }}
                onClick={onSaveStringPress}
              >
                <FaSave /> SAVE STRING
              </button>
            </View>
          ) : null}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              style={{
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                fontSize: width / 80,
                marginRight: 5,
                fontWeight: "700",
                borderWidth: 0,
                backgroundColor: "#ffa500",
                borderRadius: 2,
              }}
              onClick={onLoadSaveStringPress}
            >
              <FaCloudDownloadAlt /> LOAD SAVED STRING
            </button>
            <TouchableOpacity
              style={{
                padding: 10,
                marginTop: 10,
                marginBottom: 10,
                fontSize: width / 80,
                marginLeft: 5,
                fontWeight: "700",
                color: "lime",
                borderWidth: 1,
                borderColor: "lime",
                backgroundColor: "transparent",
                borderRadius: 2,
              }}
              onPress={onPastePress}
            >
              <FaClipboard /> PASTE FROM CLIPBOARD
            </TouchableOpacity>
          </View>
          <View
            style={{
              backgroundColor: "#00ced1",
              paddingVertical: 5,
              paddingHorizontal: 30,
              justifyContent: "center",
              alignItems: "center",
              margin: 5,
            }}
          >
            <img
              src={RotateImg}
              alt="rotate_animated_icon"
              style={{ width: 40 }}
            />
            <Text
              style={{
                color: "#131313",

                letterSpacing: 0.5,
                fontSize: width / 25,
                textAlign: "center",
              }}
            >
              Rotate to landscape to continue .
            </Text>
          </View>
        </View>
      ) : (
        !isFullScreen && (
          <View
            style={{
              width: "100%",
              height: "100%",
              margin: -5,
              overflow: "auto",
              position: "absolute",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#131313",
              zIndex: 5,
            }}
          >
            <View
              style={{
                flex: 1,
                padding: 20,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Logo size={18} />

              <View
                style={{
                  flexDirection: props.matchString?.[matchId]
                    ? "row"
                    : "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 12,
                    color: "#131313",
                    backgroundColor: "#e1e1e190",
                    padding: 5,
                  }}
                >
                  ANALYST ID : {props.analystId}
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    color: "#131313",
                    backgroundColor: "#e1e1e190",
                    padding: 5,
                    margin: 2,
                  }}
                >
                  MATCH ID : {matchId}
                </Text>
              </View>
              <View
                style={{
                  padding: 10,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ color: "#fff", paddingBottom: 5 }}>
                  PRO-MODE ( {proMode ? "ON" : "OFF"} )
                </Text>
                <Switch value={proMode} onValueChange={setProMode} />
              </View>

              {props.matchString?.[matchId] && (
                <View>
                  <Text
                    style={{
                      color: "#dddddd",
                      textAlign: "center",
                      width: "100%",
                      fontSize: 12,
                    }}
                  >
                    Coded String
                  </Text>
                  {/* <TextInput
                    editable={false}
                    style={{
                      color: "#fff",
                      borderWidth: 1,
                      borderColor: "#e1e1e1",
                      padding: 5,
                    }}
                    value={props.matchString}
                  /> */}
                  <FlatList
                    inverted
                    scrollsToTop
                    style={{
                      color: "#fff",
                      borderWidth: 1,
                      borderColor: "#e1e1e1",
                      padding: 5,
                      maxWidth: "60vw",
                    }}
                    showsHorizontalScrollIndicator={false}
                    horizontal
                    data={props.matchString?.[matchId]
                      ?.split(",")
                      ?.reverse()
                      ?.map((i) => i.toString())}
                    renderItem={({ item }) => (
                      <Text style={{ color: "#fff" }}>
                        {item}
                        {", "}
                      </Text>
                    )}
                    keyExtractor={(item, index) => item + index}
                  />

                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <button
                      style={{
                        padding: 10,
                        marginTop: 20,
                        fontSize: width / 80,
                        marginRight: 5,
                        fontWeight: "700",
                        borderWidth: 0,
                        backgroundColor: "tomato",
                        borderRadius: 2,
                      }}
                      onClick={onClearPress}
                    >
                      <FaTrash /> CLEAR STRING
                    </button>
                    <button
                      style={{
                        padding: 10,
                        marginTop: 20,
                        fontSize: width / 80,
                        marginHorizontal: 10,
                        fontWeight: "700",
                        borderWidth: 0,
                        backgroundColor: "green",
                        borderRadius: 2,
                        color: "#fff",
                      }}
                      onClick={onCopyPress}
                    >
                      <FaCopy /> COPY STRING
                    </button>
                    <button
                      style={{
                        padding: 10,
                        marginTop: 20,
                        fontSize: width / 80,
                        borderWidth: 0,
                        fontWeight: "700",
                        marginLeft: 5,
                        backgroundColor: "#00bbee",
                        color: "#fff",
                        borderRadius: 2,
                      }}
                      onClick={onSharePress}
                    >
                      <FaShare /> SHARE STRING
                    </button>
                  </View>

                  <button
                    style={{
                      padding: 10,
                      marginTop: 20,
                      fontSize: width / 80,

                      fontWeight: "700",
                      borderWidth: 0,
                      backgroundColor: "#e1e1e1",
                      borderRadius: 2,
                    }}
                    onClick={onSaveStringPress}
                  >
                    <FaSave /> SAVE STRING
                  </button>
                </View>
              )}
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  style={{
                    padding: 10,
                    marginTop: 10,
                    marginBottom: 10,
                    fontSize: width / 80,
                    marginRight: 5,
                    fontWeight: "700",
                    borderWidth: 0,
                    backgroundColor: "#ffa500",
                    borderRadius: 2,
                  }}
                  onClick={onLoadSaveStringPress}
                >
                  <FaCloudDownloadAlt /> LOAD SAVED STRING
                </button>
                <button
                  style={{
                    padding: 10,
                    marginTop: 10,
                    marginBottom: 10,
                    fontSize: width / 80,
                    marginLeft: 5,
                    fontWeight: "700",
                    color: "lime",
                    borderWidth: 1,
                    borderColor: "lime",
                    backgroundColor: "transparent",
                    borderRadius: 2,
                  }}
                  onClick={onPastePress}
                >
                  <FaClipboard /> CLIPBOARD
                </button>
              </View>
              <button
                style={{
                  padding: 20,
                  marginTop: 10,
                  marginBottom: 10,
                  fontSize: width / 70,
                  maxWidth: 150,
                  fontWeight: "700",
                  borderWidth: 0,
                  borderRadius: 5,
                  backgroundColor: "#00be11",
                  color: "#fff",
                }}
                onClick={full}
              >
                {props.matchString?.[matchId] ? "CONTINUE ANALYSIS" : "START"}
              </button>
            </View>
            {/* {fullstringanalyse && (
              <View
                style={{
                  flex: 0.5,
                  padding: 10,
                  margin: 10,
                  justifyContent: "center",
                  alignItems: "center",
                  borderWidth: 1,
                  borderRadius: 2,
                  borderColor: "#e1e1e1",
                }}
              >
                <Text
                  style={{
                    fontSize: width / 70,
                    fontWeight: "700",
                    color: "#fff",
                  }}
                >
                  FORMATTER & SUBMISSION
                </Text>

                <button
                  style={{
                    padding: 10,
                    marginTop: 10,
                    marginBottom: 10,
                    fontSize: width / 80,
                    fontWeight: "700",
                    borderWidth: 0,
                    backgroundColor: "#8a2be2",
                    color: "#fff",
                  }}
                  onClick={openFormatterHanlder}
                >
                  {formatProgress && (
                    <ActivityIndicator
                      style={{ position: "absolute", left: 0, right: 0 }}
                    />
                  )}
                  {formatProgress ? "FORMATTING..." : "FORMAT STRING"}
                </button>
                {stringLastTime && (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 5,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: 10,
                          color: "#fff",
                          opacity: 0.7,
                        }}
                      >
                        First Action Time
                      </Text>
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#fff",
                          opacity: 1,
                        }}
                      >
                        {stringStartTime}
                      </Text>
                    </View>
                    <View
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 5,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: 10,
                          color: "#fff",
                          opacity: 0.7,
                        }}
                      >
                        Last Action Time
                      </Text>
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: 11,
                          color: "#fff",
                          opacity: 1,
                        }}
                      >
                        {stringLastTime}
                      </Text>
                    </View>
                  </View>
                )}
                {originalForFormating?.length > 0 && (
                  <button
                    style={{
                      padding: 10,
                      marginTop: 10,
                      marginBottom: 10,
                      fontSize: width / 80,
                      fontWeight: "700",
                      borderWidth: 0,
                      backgroundColor: "yellow",
                      color: "#131313",
                    }}
                    onClick={gotoSubmitHandler}
                  >
                    PROCEED TO SUBMIT
                    <FaArrowRight />
                  </button>
                )}
              </View>
            )} */}
          </View>
        )
      )}
      {showBoxAlert ? (
        <BoxPopUp
          text={"Possible Missed Foul"}
          onPress={() => setShowBoxAlert(false)}
        />
      ) : null}
      {showSideChangeAlert && (
        <View
          style={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            backgroundColor: "#ffffff90",
            zIndex: 999,
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: 20,
              backgroundColor: "#131313",
            }}
          >
            <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
              Are you sure you want to change side?
            </Text>
            <View
              style={{
                width: "80%",
                flexDirection: "row",
                justifyContent: "space-evenly",
                alignItems: "center",
                backgroundColor: "#131313",
                marginTop: 20,
              }}
            >
              <TouchableOpacity onPress={confirmSideChange}>
                <Text
                  style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}
                >
                  YES
                </Text>
              </TouchableOpacity>
              <TouchableOpacity onPress={cancelSideChange}>
                <Text
                  style={{
                    fontWeight: "700",
                    fontSize: 14,
                    color: "#ffffffaa",
                  }}
                >
                  NO
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
      {showSideChangeAlert2 && (
        <View
          style={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            backgroundColor: "#ffffff90",
            zIndex: 999,
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: 20,
              backgroundColor: "#131313",
              width: 400,
            }}
          >
            <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
              Please change the Half tag FHN/SHN as required
            </Text>
            <View
              style={{
                width: "80%",
                flexDirection: "row",
                justifyContent: "space-evenly",
                alignItems: "center",
                backgroundColor: "#131313",
                marginTop: 20,
              }}
            >
              <TouchableOpacity onPress={() => setShowSideChangeAlert2(false)}>
                <Text
                  style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}
                >
                  OK
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
      <View
        style={[
          styles.top,
          {
            flexDirection: secondHalf ? "row-reverse" : "row",
            minHeight: "65%",
            height: height / 2,
            paddingTop: 7,
          },
        ]}
      >
        <View
          style={{
            flex: 1,
            padding: 5,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TeamLayout
            side={secondHalf ? "right" : "left"}
            onPress={playerPress}
            teamAnnotation="A"
            gkJr={teamAGK}
            setGkJr={setTeamAGK}
            teamDetails={teamADetails}
            layoutWidth={width}
            players={teamAPlayers}
          />
        </View>
        <View style={{ flex: 2, padding: 10 }}>
          <PositionLayedMap onPress={onFieldPress} newCordSystem={true} />
        </View>
        <View
          style={{
            flex: 1,
            padding: 5,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TeamLayout
            side={secondHalf ? "left" : "right"}
            onPress={playerPress}
            teamAnnotation="B"
            gkJr={teamBGK}
            setGkJr={setTeamBGK}
            teamDetails={teamBDetails}
            layoutWidth={width}
            players={teamBPlayers}
          />
        </View>
      </View>
      <View
        style={[
          styles.bottom,
          {
            flexDirection: "row",
            minHeight: "32.5%",
            // height: width / 6.5,
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 5,
          },
        ]}
      >
        <View style={{ flex: 1, justifyContent: "space-between" }}>
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <GroupButtons label="PASSING" layoutWidth={width}>
              {proMode ? (
                <EventButton
                  layoutWidth={width}
                  value={"PS"}
                  color="#F5D63D"
                  onPress={onKeyPress}
                  first={true}
                />
              ) : (
                <>
                  <EventButton
                    layoutWidth={width}
                    value={"SP"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                    first={true}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"LP"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                    first={true}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"C"}
                    color="#F5D63D"
                    onPress={onKeyPress}
                    first={true}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                  />
                </>
              )}
              <EventButton
                layoutWidth={width}
                value={"TB"}
                color="#F5D63D"
                onPress={onKeyPress}
                last={true}
              />
            </GroupButtons>
            <GroupButtons label="DEFENSE" layoutWidth={width}>
              <EventButton
                layoutWidth={width}
                value={"ST"}
                color="#78C5D6"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"SL"}
                color="#78C5D6"
                onPress={onKeyPress}
              />
              <EventButton
                layoutWidth={width}
                value={"IN"}
                color="#78C5D6"
                onPress={onKeyPress}
              />
              <EventButton
                layoutWidth={width}
                value={"CL"}
                color="#78C5D6"
                onPress={onKeyPress}
              />
              <EventButton
                layoutWidth={width}
                value={"PR"}
                color="#78C5D6"
                onPress={onKeyPress}
                last
              />
            </GroupButtons>
            <GroupButtons label="SHOOTING" layoutWidth={width}>
              {proMode ? (
                <EventButton
                  layoutWidth={width}
                  value={"SHT"}
                  color="#F28C33"
                  onPress={onKeyPress}
                  first
                />
              ) : (
                <>
                  <EventButton
                    layoutWidth={width}
                    value={"LS"}
                    color="#F28C33"
                    onPress={onKeyPress}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"CS"}
                    color="#F28C33"
                    onPress={onKeyPress}
                    containerStyle={{
                      paddingHorizontal: width / 80,
                      marginHorizontal: 2,
                    }}
                    first
                  />
                </>
              )}
            </GroupButtons>
            <GroupButtons label="PHYSICAL" layoutWidth={width}>
              <EventButton
                layoutWidth={width}
                value={"H"}
                color="#E868A2"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"AD"}
                color="#E868A2"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"GD"}
                color="#E868A2"
                onPress={onKeyPress}
                first
              />
            </GroupButtons>
            <GroupButtons label="BALL CONTROL" layoutWidth={width}>
              <EventButton
                layoutWidth={width}
                value={"DR"}
                color="#79C267"
                onPress={onKeyPress}
                first
              />
              <EventButton
                layoutWidth={width}
                value={"T"}
                color="#79C267"
                onPress={onKeyPress}
                first
              />
            </GroupButtons>
          </View>
          <View
            style={{
              flex: 1,
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <View style={{ flex: 1, justifyContent: "space-evenly" }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <GroupButtons label="SPECIAL" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"THW"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"OFF"}
                    label={"OF"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"HB"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                   <EventButton
                    layoutWidth={width}
                    value={"DL"}
                    color="#C5D647"
                    onPress={onKeyPress}
                    first
                  />
                </GroupButtons>
                <GroupButtons label="GOAL KEEPING" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"GS"}
                    color="#B095E2"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"GH"}
                    color="#B095E2"
                    onPress={onKeyPress}
                    first
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"GT"}
                    color="#B095E2"
                    onPress={onKeyPress}
                    first
                  />
                </GroupButtons>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <GroupButtons label="LEFT FOOT" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"L"}
                    color="#717171"
                    onPress={onKeyPress}
                    textStyle={{ color: "#fff" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                    }}
                  />
                </GroupButtons>
                <GroupButtons label="NOTATION" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={"0"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"1"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"2"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"3"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                  <EventButton
                    layoutWidth={width}
                    value={"4"}
                    color="transparent"
                    onPress={onKeyPress}
                    textStyle={{ color: "#717171" }}
                    containerStyle={{
                      paddingLeft: width / 50,
                      paddingRight: width / 50,
                      borderWidth: 2,
                      borderColor: "#717171",
                    }}
                  />
                </GroupButtons>
              </View>
            </View>
            <View
              style={{
                flex: 0.5,
                justifyContent: "space-evenly",
                alignItems: "flex-start",
                marginHorizontal: 5,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginLeft: 10,
                }}
              >
                <View style={{ marginRight: 15 }}>
                  <GroupButtons label="BALL CONTROL" layoutWidth={width}>
                    <EventButton
                      layoutWidth={width}
                      value={"PC"}
                      color="#C6C6C6"
                      onPress={onKeyPress}
                      first
                    />
                  </GroupButtons>
                </View>

                <GroupButtons label="HALF TAG" layoutWidth={width}>
                  <EventButton
                    layoutWidth={width}
                    value={halfTag}
                    color="#FEC5D2"
                    onPress={onHalfTag}
                    first
                  />
                </GroupButtons>
              </View>

              <View style={{ width: "100%" }}>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      paddingHorizontal: 5,
                      paddingVertical: 2,
                      backgroundColor: "lime",
                    }}
                  >
                    <Text
                      style={{
                        color: "#007FEB",
                        fontWeight: "700",
                        fontSize: width / 120,
                        textAlign: "center",
                      }}
                    >
                      CURRENT ACTION
                    </Text>
                    <Text
                      style={{
                        flex: 1,
                        backgroundColor: "#fff",
                        fontSize: width / 110,
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {currAction}
                    </Text>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      paddingHorizontal: 5,
                      paddingVertical: 2,
                      backgroundColor: "lime",
                    }}
                  >
                    <Text
                      style={{
                        color: "#007FEB",
                        fontWeight: "700",
                        fontSize: width / 120,
                        textAlign: "center",
                      }}
                    >
                      RECIEVER ACTION
                    </Text>
                    <Text
                      style={{
                        flex: 1,
                        backgroundColor: "#fff",
                        fontSize: width / 110,
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {secondAction}
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    width: "100%",
                    backgroundColor: "#EEF7FE",
                    paddingLeft: 10,
                    paddingRight: 10,
                    paddingTop: 2,
                    paddingBottom: 2,
                  }}
                >
                  <Text
                    style={{
                      width: "100%",
                      color: "#007FEB",
                      fontSize: width / 130,
                    }}
                  >
                    CODED STRING
                  </Text>
                  {/* <TextInput
                    value={fullstringanalyse}
                    numberOfLines={1}
                    editable={false}
                    style={{
                      width: "100%",
                      height: 10,
                      // minHeight: width / 100,
                      backgroundColor: "#fff",
                      paddingLeft: 5,
                      fontSize: width / 130,
                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                  /> */}
                  <FlatList
                    inverted
                    scrollsToTop
                    style={{
                      width: "100%",
                      height: 10,
                      backgroundColor: "#fff",
                      paddingLeft: 5,

                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                    showsHorizontalScrollIndicator={false}
                    horizontal
                    data={fullstringanalyse
                      ?.split(",")
                      ?.reverse()
                      ?.map((i) => i.toString())}
                    renderItem={({ item }) => (
                      <Text style={{ color: "#131313", fontSize: width / 130 }}>
                        {item}
                        {", "}
                      </Text>
                    )}
                    keyExtractor={(item, index) => item + index}
                  />
                </View>
              </View>
            </View>
            <View
              style={{
                flex: 0.7,
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              <GroupButtons label="SPECIAL EVENTS" layoutWidth={width} wrapped>
                <EventButton
                  layoutWidth={width}
                  value={"CN"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                  containerStyle={{ marginBottom: 5 }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"FK"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                  containerStyle={{ marginBottom: 5 }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"PK"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                  containerStyle={{ marginBottom: 5 }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"F"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                  containerStyle={{
                    marginBottom: 5,
                    paddingLeft: width / 50,
                    paddingRight: width / 50,
                  }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"GK"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                  containerStyle={{ marginTop: 5 }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"OG"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                  containerStyle={{ marginTop: 5 }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"G"}
                  color="#76BFF9"
                  onPress={onKeyPress}
                />
                <EventButton
                  layoutWidth={width}
                  value={"YC"}
                  color="#F5D63D"
                  onPress={onKeyPress}
                  containerStyle={{ marginTop: 5 }}
                />
                <EventButton
                  layoutWidth={width}
                  value={"RC"}
                  color="#F65E5E"
                  onPress={onKeyPress}
                  containerStyle={{ marginTop: 5 }}
                />
              </GroupButtons>
            </View>
          </View>
        </View>
        <View style={{ justifyContent: "space-between", paddingBottom: 5 }}>
          <EventButton
            layoutWidth={width}
            value={"SIDE CHANGE"}
            color="#2699FB"
            onPress={handleSideChange}
            first
          />
          <EventButton
            layoutWidth={width}
            value={"BACK SPACE"}
            color="#2699FB"
            onPress={onKeyPress}
            first
          />
          <EventButton
            layoutWidth={width}
            value={"NEXT"}
            color="#2699FB"
            onPress={onNextPress}
            first
          />
          <EventButton
            layoutWidth={width}
            value={"DONE"}
            color="green"
            onPress={onDonePress}
            first
          />
        </View>
      </View>
    </View>
  );
};

const GroupButtons = ({ children, label, layoutWidth, vertical, wrapped }) => {
  return (
    <View
      style={{
        flexDirection: vertical && "row",
        borderWidth: wrapped && 1,
        borderStyle: "dashed",
        padding: wrapped && 5,
      }}
    >
      {wrapped && (
        <View
          style={{
            position: "absolute",
            bottom: -8,
            left: 0,
            right: 0,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontSize: layoutWidth / 200,
              color: "#131313",
              opacity: 0.7,
              fontWeight: "700",
              letterSpacing: 0.25,
            }}
          >
            {label}
          </Text>
        </View>
      )}
      <View
        style={{
          width: !vertical && "100%",
          flexDirection: "row",
          justifyContent: wrapped ? "flex-start" : "space-between",
          alignItems: "center",
          flexWrap: wrapped && "wrap",
        }}
      >
        {children}
      </View>
      {!wrapped && (
        <View
          style={{
            width: !vertical && "100%",
            height: vertical && "100%",
            paddingTop: 5,
            flexDirection: vertical ? "column" : "row",
          }}
        >
          {vertical ? (
            <View
              style={{
                width: "10%",
                flex: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderStyle: "dashed",
              }}
            />
          ) : (
            <View
              style={{
                flex: 1,
                borderLeftWidth: 1,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            />
          )}
          <Text
            style={{
              fontSize: layoutWidth / 200,
              color: "#131313",
              opacity: 0.7,
              fontWeight: "700",
              letterSpacing: 0.25,
            }}
          >
            {label}
          </Text>
          {vertical ? (
            <View
              style={{
                flex: 1,
                width: "10%",
                borderRightWidth: 1,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            />
          ) : (
            <View
              style={{
                flex: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            />
          )}
        </View>
      )}
    </View>
  );
};

const EventButton = ({
  value,
  onPress,
  color = "#131313",
  layoutWidth = 1,
  textStyle,
  containerStyle,
  label,
}) => {
  return (
    <TouchableOpacity
      onPress={() => onPress(value)}
      style={{
        justifyContent: "center",
        alignItems: "center",
        paddingTop: layoutWidth / 140,
        paddingBottom: layoutWidth / 140,
        paddingLeft: layoutWidth / 80,
        paddingRight: layoutWidth / 80,
        backgroundColor: color,
        marginHorizontal: 5,
        borderRadius: 2,
        outline: "none",
        boxShadow: "0pc 1px 3px #13131340",
        ...containerStyle,
      }}
    >
      <Text
        style={{ fontWeight: "700", fontSize: layoutWidth / 80, ...textStyle }}
      >
        {label ? label : value}
      </Text>
    </TouchableOpacity>
  );
};

const BoxPopUp = ({ text, onPress }) => {
  return (
    <View
      style={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        backgroundColor: "#ffffff90",
        zIndex: 999,
      }}
    >
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
          backgroundColor: "#131313",
        }}
      >
        <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
          {text}
        </Text>
        <View
          style={{
            width: "80%",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
            backgroundColor: "#131313",
            marginTop: 20,
          }}
        >
          <TouchableOpacity onPress={onPress}>
            <Text style={{ fontWeight: "700", fontSize: 14, color: "#fff" }}>
              OK
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const TeamLayout = ({
  layoutWidth,
  teamDetails,
  teamName,
  side,
  teamAnnotation,
  players = [],
  onPress,
  onFocus,
  gkJr,
  setGkJr,
}) => {
  return (
    <View
      style={{
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <FlatList
        style={{ maxHeight: "55vh" }}
        ListHeaderComponentStyle={{
          paddingLeft: 5,
          paddingRight: 5,
        }}
        ListHeaderComponent={
          <View
            style={{
              width: "100%",
              flexDirection: side === "left" ? "row" : "row-reverse",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: layoutWidth / 100, fontWeight: "700" }}>
              {teamDetails && teamDetails.name}
            </Text>
            <Text style={{ fontSize: layoutWidth / 100, fontWeight: "700" }}>
              TEAM {teamAnnotation}
            </Text>
          </View>
        }
        numColumns={3}
        data={players}
        extraData={players}
        ListFooterComponent={
          <View>
            <Text>GK</Text>
            <TextInput
              // onPress={(e) => {
              //   onPress(item, teamAnnotation);
              // }}
              placeholder="Jr No"
              value={gkJr}
              onChangeText={setGkJr}
              style={{
                width: layoutWidth / 23,
                height: layoutWidth / 23,
                borderRadius: 5,
                margin: 7,
                backgroundColor: "#EEF7FE",
                boxShadow: "0px 1px 6px #13131370",
                justifyContent: "center",
                alignItems: "center",
                outline: "none",
                textAlign: "center",
                fontSize: layoutWidth / 85,
                fontWeight: "700",
              }}
            />
          </View>
        }
        renderItem={({ item }) => (
          <TouchableOpacity
            onPress={(e) => {
              onPress(item, teamAnnotation);
            }}
            style={{
              width: layoutWidth / 23,
              height: layoutWidth / 23,
              borderRadius: 5,
              margin: 7,
              backgroundColor: "#EEF7FE",
              boxShadow: "0px 1px 6px #13131370",
              justifyContent: "center",
              alignItems: "center",
              outline: "none",
            }}
          >
            <Text style={{ fontSize: layoutWidth / 85, fontWeight: "700" }}>
              {item}
            </Text>
          </TouchableOpacity>
        )}
        keyExtractor={(item) => item.toString()}
      />
    </View>
  );
};

const mapStateToProps = (state) => {
  return {
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    videoControl: state.control.videoControl,
    matchString: state.control.analysedString,
    controllerWindowState: state.control.controllerWindowState,
    analystId: state.auth.analyst_id,
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, {
  SetCurrentAction,
  SetFullAnalyseString,
  AddToActionLog,
  ClearActionLog,
  ClearCurrentAction,
  ClearFullAnalyseString,
  SetVideoControl,
  PushMatchStringToServer,
  FetchMatchStringFromServer,
})(InputBoard);

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    justifyContent: "space-between",
    padding: 5,
    overflow: "hidden",
  },
  top: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  bottom: {
    width: "100%",
  },
});
